//const OPENAI_API_KEY = "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"
export const GetDefinitionByChatGpt = async (name, setData, OPENAI_API_KEY) => {
    console.log("---> handlSearchGpt");
    const prompt = "Erstelle mir eine Definition von dem folgenden Begriff: " + name + ". Füge auch mindestens drei Beispiele hinzu, um die Definition besser zu verstehen. Formatiere dies als HTML, lasse aber die Überschrift weg";

    if (name !== "") {
        try {
            console.log("---> Sending request to OpenAI API");
            const response = await fetch("https://api.openai.com/v1/chat/completions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${OPENAI_API_KEY}`,
                },
                body: JSON.stringify({
                    model: "gpt-3.5-turbo", // Oder gpt-3.5-turbo
                    messages: [{ role: "user", content: prompt }],
                }),
            });

            const data = await response.json();
            const content = data.choices[0].message.content;
            console.log(data.choices[0].message.content);
            console.log(data);

            setData((prevData) => ({ ...prevData, description: content }));
        } catch (error) {
            console.error("Error while fetching data from OpenAI API:", error);
        }
    } else {
        console.log("Name is empty");
    }
};


export const GetRelatinDefinitionByChatGpt = async (from, to, setData, OPENAI_API_KEY) => {
    console.log("---> handlSearchGpt");
    const prompt = ("Erstelle mir eine Beschreibung wie die beiden Begriffe im Zusamenhang stehen: " + from + " und " + to + "."
        + "Füge auch ein Beispiele hinzu, um die Beschreibung besser zu verstehen."
        + "Formatiere dies als HTML, lasse aber die Überschrift weg");


    console.log("from: " + from);
    console.log("to: " + to);
    console.log("prompt: " + prompt);
    console.log("OPENAI_API_KEY: " + OPENAI_API_KEY);
    
    if (from !== "" && to !== "") {
        try {
            console.log("---> Sending request to OpenAI API");
            const response = await fetch("https://api.openai.com/v1/chat/completions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${OPENAI_API_KEY}`,
                },
                body: JSON.stringify({
                    model: "gpt-3.5-turbo", // Oder gpt-3.5-turbo
                    messages: [{ role: "user", content: prompt }],
                }),
            });

            const data = await response.json();
            const content = data.choices[0].message.content;
            console.log(data.choices[0].message.content);
            console.log(data);

            setData((prevData) => ({ ...prevData, description: content }));
        } catch (error) {
            console.error("Error while fetching data from OpenAI API:", error);
        }
    } else {
        console.log("Name is empty");
    }
};

export const GetRelatinTypeByChatGpt = async (from, to, setData, OPENAI_API_KEY) => {
    console.log("---> handlSearchGpt");
    const prompt = ("Finde mir einen Sematischen relationstype zwischen den beiden Begriffe: " + from + " und " + to + "."
        + "Mache das so kompakt wie möglich und ohne Beispiele.");


    console.log("from: " + from);
    console.log("to: " + to);
    console.log("prompt: " + prompt);
    console.log("OPENAI_API_KEY: " + OPENAI_API_KEY);
    
    if (from !== "" && to !== "") {
        try {
            console.log("---> Sending request to OpenAI API");
            const response = await fetch("https://api.openai.com/v1/chat/completions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${OPENAI_API_KEY}`,
                },
                body: JSON.stringify({
                    model: "gpt-3.5-turbo", // Oder gpt-3.5-turbo
                    messages: [{ role: "user", content: prompt }],
                }),
            });

            const data = await response.json();
            const content = data.choices[0].message.content;
            console.log(data.choices[0].message.content);
            console.log(data);

            setData((prevData) => ({ ...prevData, name: content }));
        } catch (error) {
            console.error("Error while fetching data from OpenAI API:", error);
        }
    } else {
        console.log("Name is empty");
    }
};